/* eslint-disable no-unused-vars */
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../../root-store-context";
import { Card, Flex, Radio, RadioChangeEvent, Space } from "antd";

export const Options = observer(() => {
  const { applicationStore } = useStore();
  const [deliveryHelpText, setDeliveryHelpText] =
    React.useState<string>(undefined);

  const onChangeDeliveryMethod = (e: RadioChangeEvent) => {
    applicationStore.setDeliveryMethod(e.target.value);
    const selectedDeliveryMethod =
      applicationStore.selectedDeliveryMethod.find(
        (i) => i.id === e.target.value
      );
    if (selectedDeliveryMethod) {
      applicationStore
        .getSelectedHelpText(selectedDeliveryMethod.methodName)
        .then((res) => setDeliveryHelpText(res));
    }
  };

  const onChangePrintPreferences = (e: RadioChangeEvent) => {
    applicationStore.setPrintPreferences(e.target.value);
  };

  const onChangeColorMode = (e: RadioChangeEvent) => {
    applicationStore.setColorMode(e.target.value);
  };

  const deliveryMethods = applicationStore.selectedDeliveryMethod.filter(
    (i) => i.dm_Active === 1
  );
  const printPreferenceMethods =
    applicationStore.selectedPrintPreferenceMethod.filter((i) => i.pp_Active === 1);
  const printColorMethod =
    applicationStore.selectedPrintColorMethod.filter((i) => i.pc_Active === 1);

  return (
    <Flex vertical gap="10px">
      {deliveryMethods.length > 0 && (
        <div
          style={{
            flex: "1 1 100%",
            display: "flex",
            alignItems: "center",
            gap: "40px",
          }}
        >
          <Card title="Delivery Method" style={{ width: 300 }}>
            <Radio.Group
              data-testid="cam-delivery-method-radio-group"
              onChange={onChangeDeliveryMethod}
              value={applicationStore.mailJob.deliveryMethodId}
            >
              <Space direction="vertical">
                {deliveryMethods.map((i) => (
                  <Radio key={i.id} value={i.id}>
                    {i.methodName}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Card>
          <p>{deliveryHelpText}</p>
        </div>
      )}
      {printPreferenceMethods.length > 0 && (
        <div style={{ flex: "1 1 100%" }}>
          <Card title="Print Preferences" style={{ width: 300 }}>
            <Radio.Group
              data-testid="cam-print-preferences-radio-group"
              onChange={onChangePrintPreferences}
              value={applicationStore.mailJob.printPreferenceMethodId}
            >
              <Space direction="vertical">
                {printPreferenceMethods.map((i) => (
                  <Radio key={i.id} value={i.id}>
                    {i.optionName}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Card>
        </div>
      )}
      {printColorMethod.length > 0 && (
        <div style={{ flex: "1 1 100%" }}>
          <Card title="Color Mode" style={{ width: 300 }}>
            <Radio.Group
              data-testid="cam-color-mode-radio-group"
              onChange={onChangeColorMode}
              value={applicationStore.mailJob.printColorId}
            >
              <Space direction="vertical">
                {printColorMethod.map((i) => (
                  <Radio key={i.id} value={i.id}>
                    {i.optionName}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Card>
        </div>
      )}
    </Flex>
  );
});
